import { render } from "./Compliance.vue?vue&type=template&id=127816c6&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"

import "./Compliance.vue?vue&type=style&index=0&id=127816c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-127816c6"

export default script